<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Heart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.stHeart1{fill:#FFFFFF;}
	.stHeart2{fill:#FF4033;enable-background:new    ;}
</style>
<path class="stHeart1" d="M238.3,173l17.7,18l17.7-18c29.4-29.8,77.1-29.8,106.4,0c29.4,29.8,29.4,78.2,0,107.1L278.5,384.2
	c-6.2,6.3-14.4,9.4-22.5,9.4s-16.3-3.1-22.5-9.4L131.9,280.1c-29.4-28.9-29.4-77.3,0-107.1C161.2,143.2,208.9,143.2,238.3,173
	L238.3,173z"/>
<path class="stHeart2" d="M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256S397.4,512,256,512S0,397.4,0,256z M233.5,384.2
	c6.2,6.3,14.4,9.4,22.5,9.4s16.3-3.1,22.5-9.4l101.6-104.1c29.4-28.9,29.4-77.3,0-107.1c-29.3-29.8-77-29.8-106.4,0L256,191
	l-17.7-18c-29.4-29.8-77.1-29.8-106.4,0c-29.4,29.8-29.4,78.2,0,107.1L233.5,384.2z"/>
</svg>